/** @format */

import {AxiosInstance} from "../../../utils/AxiosInstance";
import { environment } from "../../../env";

const axiosInstance = (new AxiosInstance(`${environment.API}/survey/`, 'survey')).getAxiosInstance()

const SERVICE = {
  getAll: () => axiosInstance.get("allSurvey"),
  getSurveyByID: (surveyId) => axiosInstance.get(`findBySurveyId?id=${surveyId}`),
  addSurvey: (surveyToAdd) => axiosInstance.post("createSurvey", surveyToAdd),
  updateSurvey: (surveyToUpdate) => axiosInstance.put("updateQuestionnaire", surveyToUpdate),
  deleteSurvey: (surveyId) => axiosInstance.put(`surveyActivity?id=${surveyId}&action=R`, null),
  publishSurvey: (surveyId) => axiosInstance.put(`surveyActivity?id=${surveyId}&action=A`, null),
  stopSurvey: (surveyId) => axiosInstance.put(`surveyActivity?id=${surveyId}&action=C`, null),
  surveyExistence: () => axiosInstance.get("surveyExistence"),
  getIndividualReport: (surveyId) => axiosInstance.get(`individualReport?id=${surveyId}`),
  getSurveySummary: (surveyId) => axiosInstance.get(`consolidatedReport?id=${surveyId}`),
};

export default SERVICE;
